const baseUrl = globalThis.env?.BASE_URL || process?.env?.BASE_URL

export function unpackURL(url) {
  if (!url) return url
  if (url.startsWith('images://')) {
    return url.replace('images://', `${baseUrl}/images/`)
  }
  return url
}
